import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    homeFunc();
});

const homeSwiper = new Swiper(".home-swiper", {
  loop: true,
  slidesPerView: 2,
  spaceBetween: 15,
  speed: 6000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

//ヘッダー分下げる
$(window).on('load resize', function(){
  var height=$(".l-header").height();
  $(".l-drawer").css("padding-top", height);
  // $(".l-page__wrapper").css("padding-top", height);
});

//アコーディオン
$(".js-ac_btn").on('click',function(){
  if($(this).hasClass("is-open")){
    $(this).removeClass("is-open");
    $(this).next(".js-ac_body").slideUp();
  }else{
    $(this).addClass("is-open");
    $(this).next(".js-ac_body").slideDown();
  }
});
